import axios from '_u/axios'

//查询组织机构树列表
export const orgTree = () => {
    return axios.post('api/admin/sys/org/tree')
}

//查询组织机构树列表
export const estateOrgTree = (body) => {
    /* body
        type: 
    */
    return axios.post('api/admin/sys/org/estateOrgTree', body)
}

// 查询岗位列表
export const orgList = (body) => {
    return axios.post('api/sys/org/list', body)
}

//删除机构
export const orgDelete = (id) => {
    return axios.post('api/sys/org/delete', { id })
}

//新增
export const orgAdd = (body) => {
    return axios.post('api/sys/org/add', body)
}

//修改
export const orgUpdate = (body) => {
    return axios.post('api/sys/org/update', body)
}

// 查询组织明细
export const orgView = (id) => {
    return axios.post('api/sys/org/view', { id })
}

// 根据角色查询已拥有权限
export const queryOrgAuth = (orgId) => {
    return axios.post('api/sys/org/queryAuth', { orgId })
}

// 系统-岗位查人员
export const usersByOrg = (body) => {
    if (typeof body === 'string') {
        body = {
            orgName: body,
        }
    }

    return axios.post('api/sys/org/usersByOrg', body)
}
